import { DEALS_FEATURE } from '@/constants/experimentConstants';
import { useConfidenceFlag } from '@/hooks/useConfidenceFlag';
import { NotFound } from '@/pages/_exports';

/**
 * Keeping stuff dry, when deals feature is fully rolled out, we can remove this HOC wrapper
 * for deals pages
 */
const withDealsFeatureFlag = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: P) => {
    const { flagValue } = useConfidenceFlag(DEALS_FEATURE.name, DEALS_FEATURE.defaultValue, false);

    if (!flagValue?.enabled) return <NotFound />;
    return <Component {...props} />;
  };
};

export default withDealsFeatureFlag;
